import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import { Lock } from "@/api/locks";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { loadHandbooks } from "@/utils/loadHandbooks";

interface ICreatePasscodeForm {
  passcode: string;
}

const createPasscodeFields: InputField[] = [
  {
    label: "Пароль",
    name: "passcode",
    placeholder: "Офис 1",
    type: "text",
    isRequired: true,
    pattern: /[0-9]{4}/,
    patternMessage: 'Пароль должен состоять из 4 цифр'
  },
];

export function CreatePasscodeModal({
  disclosure,
  lock,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  lock: Lock | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: ICreatePasscodeForm) => {
    return new Promise<boolean>(async (resolve, _reject) => {
      api.locks
        .createPasscode(lock!.id, {
          passcode: data.passcode,
          lock_id: lock!.id,
        })
        .then((_data) => {
          loadHandbooks({ handbooks: ["locks"] });
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание пароля"
      modalErrors={modalErrors}
      fields={createPasscodeFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
}
